<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Thermometer Snowflake" class="d-icon d-icon--thermometer-snowflake" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.5a.5.5 0 0 0-.5.5v5.27a.5.5 0 0 1-.25.433 1.5 1.5 0 1 0 1.5 0 .5.5 0 0 1-.25-.433V2a.5.5 0 0 0-.5-.5ZM7.94.94A1.5 1.5 0 0 1 10.5 2v5.002a2.5 2.5 0 1 1-3 0V2c0-.398.158-.78.44-1.06Z"/><path d="M.5 6a.5.5 0 0 1 .5-.5h.793l-.647-.646a.5.5 0 1 1 .708-.708L3.207 5.5H4v-.793L2.646 3.354a.5.5 0 1 1 .708-.708L4 3.293V2a.5.5 0 0 1 1 0v1.293l.646-.647a.5.5 0 1 1 .708.708L5 4.707V5.5h1a.5.5 0 0 1 0 1H5v.793l.604.603A.5.5 0 0 1 5 8.683V10a.5.5 0 0 1-1 0V8.707l-.646.647a.5.5 0 1 1-.708-.708L4 7.293V6.5h-.793L1.854 7.854a.5.5 0 1 1-.708-.708l.647-.646H1A.5.5 0 0 1 .5 6Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconThermometerSnowflake',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
